// ============================================================================
// TrainerCalendarSync — the trainer's "Sync to your calendar" section, wiring
// the trainer ICS-subscription hooks to the shared CalendarSubscribeCard. Used
// in two places (the Calendar area and the Account page) so the trainer can find
// their feed URL wherever they think to look. The feed covers ALL their clients'
// scheduled sessions, read-only + auto-updating.
//
// Strings come from the `common` namespace under the `calendarSync.*` subtree
// (the trainer realm's default NS), the same key shape the client portal mirrors
// in its own namespace — one component, identical copy contract.
// ============================================================================
import { useTranslation } from "react-i18next";
import { CalendarSubscribeCard } from "../../components";
import {
  useCalendarSubscription,
  useRotateCalendarSubscription,
} from "../../hooks";

export function TrainerCalendarSync({ className }: { className?: string }) {
  const { t } = useTranslation("common", { keyPrefix: "calendarSync" });
  const sub = useCalendarSubscription();
  const rotate = useRotateCalendarSubscription();

  return (
    <CalendarSubscribeCard
      t={t}
      url={sub.data?.ics_url ?? null}
      isLoading={sub.isLoading}
      isError={sub.isError}
      onRetry={() => void sub.refetch()}
      onRotate={() => rotate.mutate()}
      isRotating={rotate.isPending}
      rotateFailed={rotate.isError}
      className={className}
    />
  );
}
